// extracted by mini-css-extract-plugin
export default {"background":"Extra_background__ahyON"};